<template>
    <div>   
        <not-toolbar-sub :not="not"/> 
        <v-layout align-center="" justify-center="">
            <v-col sm="12" cols="12">
                <br>
                <v-card > 
                    <mbs-page-tab :items="tab"></mbs-page-tab> 
                    <mbs-item-manager
                        :top_label="false"
                        :name_items="NAME_ITEMS"
                        :name_item="NAME_ITEM"
                        :value_items="VALUE_ITEMS"
                        :value_item="VALUE_ITEM" 
                        :field_items="DATA.FIELDS.reporters"
                        :header_items="HEADER_ITEMS"
                        :header_items2="HEADER_ITEMS2"
                        :data_items="ReportersData"   
                        :is_joined="true"  
                        :path_item="PATH_ITEM"   
                        :select_items="DataSelector"   
                        @SELECT_ITEM_ACTION="ITEM_ACTION"
                        @SELECT_TABLE_ACTION="TABLE_ACTION"
                    />
                </v-card>
                <br><br>
            </v-col>  
        </v-layout>
        <!-- <v-container grid-list-xl> 
        </v-container>   -->

        <!-- //DIALOGS -->
        <div>
            <v-dialog  v-model="dialog_allowed_centres"   persistent max-width="1200px"> 
              <v-card   tile height="100%" color="">
                  <v-layout column fill-height>
                      <template v-if="SELECTED_ITEM">
                          <v-card-title class="primary white--text" dark>
                              <v-btn  @click="dialog_allowed_centres=false" color="white" icon="" class="ml-2 mr-5"><v-icon size="" >mdi-map-marker-distance</v-icon></v-btn>
                              <span class="headline">Manage  "{{ SELECTED_ITEM.first_name }} {{ SELECTED_ITEM.last_name }}" Reporting Centre</span>
                              <v-spacer></v-spacer>   
                              <v-btn  @click="dialog_allowed_centres=false" color="white" icon="" class="ml-2"><v-icon size="" class="pr-1">mdi-close</v-icon></v-btn> 
                          </v-card-title>  
                          <v-card-text >   
                            <v-card class="ma-5">
                                <mbs-item-manager
                                    :top_label="false"
                                    :name_items="'Allocated Locations'"
                                    :name_item="'Allocated Location'"
                                    :value_items="VALUE_ITEMS"
                                    :value_item="VALUE_ITEM" 
                                    :field_items="DATA.FIELDS.select_centres"
                                    :header_items="CENTRE_HEADER_ITEMS" 
                                    :data_items="CENTRE_ITEMS"   
                                    :is_joined="true"  
                                    :path_item="CENTRE_PATH_ITEM"   
                                    :select_items="DataSelector"   
                                    @SELECT_ITEM_ACTION="ITEM_ACTION"
                                    @SELECT_TABLE_ACTION="TABLE_ACTION"
                                />

                            </v-card>
                          </v-card-text>    
                      </template>
                      <template v-else>
                          <v-card>
                              <v-layout justify-center align-center class="pa-5">
                                  No selected item
                              </v-layout>
                          </v-card>
                      </template>
                      <v-spacer></v-spacer>
                      <div >
                          <v-divider></v-divider>
                          <v-layout justify-center="" class="px-5 py-5">  
                              <v-spacer></v-spacer>
                              <v-btn outlined @click="dialog_allowed_centres=false" color="primary" >CLOSE</v-btn> 
                          </v-layout>   
                      </div> 
                  </v-layout>
              </v-card>
          </v-dialog>

        </div>
    </div> 
</template>

<script>
    import DATA from '../../../plugins/DATA'
    import {mapState} from "vuex"
    let PAGE_NAME = DATA.ITEMS.REPORTERS.values    
    export default {
        name:PAGE_NAME, 
        props:['not'],  
        data() {
            return {
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,

                NAME_ITEMS:DATA.ITEMS.REPORTERS.names,
                NAME_ITEM:DATA.ITEMS.REPORTERS.name,
                VALUE_ITEMS:DATA.ITEMS.REPORTERS.values,
                VALUE_ITEM:DATA.ITEMS.REPORTERS.value,  
                DATA:DATA,
                
                SELECTED_ITEM:null,
                dialog_allowed_centres:false,
                tab:[
                    {name:"Reporters",link:"/settings/reporters"},
                    {name:"Categories",link:"/settings/reporters/categories"},
                ]
            }
        },
        created() {
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try {
                 
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: { 
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
            }),
            ...mapState({
                Reporters: state=> state.items[(DATA.ITEMS.REPORTERS.values).toUpperCase()],
                JoinedReporters: state=> state.join[(DATA.ITEMS.REPORTERS.values).toUpperCase()],
                ReporterCategories: state=> state.items[(DATA.ITEMS.REPORTER_CATEGORIES.values).toUpperCase()],
                JoinedReporterCategories: state=> state.join[(DATA.ITEMS.REPORTER_CATEGORIES.values).toUpperCase()],
                
                Regions: state=> state.items[(DATA.ITEMS.REGIONS.values).toUpperCase()],
                JoinedRegions: state=> state.join[(DATA.ITEMS.REGIONS.values).toUpperCase()],
                Districts: state=> state.items[(DATA.ITEMS.DISTRICTS.values).toUpperCase()],
                JoinedDistricts: state=> state.join[(DATA.ITEMS.DISTRICTS.values).toUpperCase()],
                Constituencies: state=> state.items[(DATA.ITEMS.CONSTITUENCIES.values).toUpperCase()],
                JoinedConstituencies: state=> state.join[(DATA.ITEMS.CONSTITUENCIES.values).toUpperCase()],
                Wards: state=> state.items[(DATA.ITEMS.WARDS.values).toUpperCase()],
                JoinedWards: state=> state.join[(DATA.ITEMS.WARDS.values).toUpperCase()],
                Centres: state=> state.items[(DATA.ITEMS.CENTRES.values).toUpperCase()],
                JoinedCentres: state=> state.join[(DATA.ITEMS.CENTRES.values).toUpperCase()],
                TraditionAuthorities: state=> state.items[(DATA.ITEMS.TRADITION_AUTHORITIES.values).toUpperCase()],
                JoinedTraditionAuthorities: state=> state.join[(DATA.ITEMS.TRADITION_AUTHORITIES.values).toUpperCase()],
            }),  
            ReportersData(){
                return this.JoinedReporters?this.JoinedReporters:this.Reporters
            },
            ReporterCategoriesData(){
                return this.JoinedReporterCategories?this.JoinedReporterCategories:this.ReporterCategories
            }, 
            RegionsData(){
                return this.JoinedRegions?this.JoinedRegions:this.Regions
            },
            DistrictsData(){
                return this.JoinedDistricts?this.JoinedDistricts:this.Districts
            },
            ConstituenciesData(){
                return this.JoinedConstituencies?this.JoinedConstituencies:this.Constituencies
            },
            WardsData(){
                return this.JoinedWards?this.JoinedWards:this.Wards
            },
            CentresData(){
                return this.JoinedCentres?this.JoinedCentres:this.Centres
            },
            TraditionAuthoritiesData(){  
                return this.JoinedTraditionAuthorities?this.JoinedTraditionAuthorities:this.TraditionAuthorities
            },
            DataSelector(){
                let ReporterCategories = this.ReporterCategoriesData
                let Regions = this.RegionsData 
                let Districts = this.DistrictsData 
                let Constituencies = this.ConstituenciesData 
                let Wards = this.WardsData
                let Centres = this.CentresData
                let TraditionAuthorities = this.TraditionAuthoritiesData
                return {
                    ReporterCategories:ReporterCategories,
                    Regions:Regions, 
                    Districts:Districts, 
                    Constituencies:Constituencies, 
                    Wards:Wards, 
                    Centres:Centres, 
                    TraditionAuthorities:TraditionAuthorities, 
                }
            }, 
            route(){
                return this.$route
            },
            vs(){
                return this.$vuetify.breakpoint
            },  
            MY_LINKS(){  
                let thisLinks = this.MBS.actions.FIND_SUB_LINKS("catalog",1,true) 
                return thisLinks
            }, 
            PATH_ITEM(){  
                let path = DATA.PATHS.reporters
                return path
            }, 
            HEADER_ITEMS(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"code",align:"center",show:true},     
                    {id:0,name:"First Name",value:"first_name",show:true},       
                    {id:0,name:"Last Name",value:"last_name",show:true},       
                    {id:0,name:"Phone ",value:"phone_number",show:true},       
                    {id:0,name:"Email",value:"email_address",show:true},       
                    {id:0,name:"Location",value:"location_address",show:false},       
                    {id:0,name:"Category",value:'reporter_category_name',show:true},     
                    {id:0,name:"Category Code",value:'reporter_category_code',show:false},     
                    {id:0,name:"Locations",value:'reporter_category_code',align:"center",show:true},     
                    {id:0,name:"create",value:'created_at_',show:false},    
                    {id:0,name:"update",value:'updated_at_',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"edit"}, 
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                        {name:"Manage Allowed Centres",action:"manage_allowed_centres",icon:"mdi-map-marker-distance"}, 
                    ]}, 
                ]
            },
            HEADER_ITEMS2(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"Number",value:'no',show:true},  
                    {id:0,name:"name",show:true}, 
                    {id:0,name:"code",align:"center",show:true},      
                    {id:0,name:"action",align:"right",show:true,item:[  
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"mdi-pencil"},
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                    ]}, 
                ]
            }, 
            CENTRE_PATH_ITEM(){  
                let item = this.SELECTED_ITEM
                if(!item){return null}
                let path = DATA.PATHS.reporters+item.key+'/allocated_locations'
                return path
            }, 
            CENTRE_ITEMS(){  
                let item = this.SELECTED_ITEM
                let reporters = this.ReportersData
                let item_key = item?item.key:null

                let Regions = this.Regions 
                let Districts = this.DistrictsData 
                let Constituencies = this.ConstituenciesData 
                let Wards = this.WardsData
                let Centres = this.CentresData
                let TraditionAuthorities = this.TraditionAuthoritiesData
                
                if(!item_key||!reporters){return null}
                let report = reporters.find(rep=>rep.key==item_key)
                let allocated_locations = report?report.allocated_locations:null
                if(!allocated_locations){return null}
                let location = []
                for (const key in allocated_locations) {
                    if (Object.hasOwnProperty.call(allocated_locations, key)) {
                        const element = allocated_locations[key];
                        //centres
                        let centre_code = element.centre_code
                        let centre = centre_code && Centres?Centres.find(centre=>centre.code == centre_code):null
                        let centre_name = centre?centre.name:null
                        
                        //wards
                        let ward_code = element.ward_code
                        let ward = ward_code && Wards?Wards.find(ward=>ward.code == ward_code):null
                        let ward_name = ward?ward.name:null
                        
                        //constituency
                        let constituency_code = element.constituency_code
                        let constituency = constituency_code && Constituencies?Constituencies.find(constituency=>constituency.code == constituency_code):null
                        let constituency_name = constituency?constituency.name:null
                        
                        //district
                        let district_code = element.district_code
                        let district = district_code && Districts?Districts.find(district=>district.code == district_code):null
                        let district_name = district?district.name:null
                        
                        //Tradition Authority
                        let tradition_authority_code = element.tradition_authority_code
                        let tradition_authority = tradition_authority_code && TraditionAuthorities?TraditionAuthorities.find(tradition_authority=>tradition_authority.code == tradition_authority_code):null
                        let tradition_authority_name = tradition_authority?tradition_authority.name:null

                        //
                        let region_code = district?district.region_code:null
                        let region = region_code && this.Regions?this.Regions.find(region=>region.code == region_code):null
                        let region_name = region?region.name:null

                        location.push({
                            ...element,
                            image_icon:{icon:'mdi-map-marker-path'},
                            icon:'mdi-map-marker-path',
                            centre:centre,
                            centre_name:centre_name,
                            ward:ward,
                            ward_name:ward_name,
                            constituency:constituency,
                            constituency_name:constituency_name,
                            district:district,
                            district_name:district_name,
                            tradition_authority:tradition_authority,
                            tradition_authority_name:tradition_authority_name,
                            region:region,
                            region_name:region_name,
                        })
                    }
                }  
                console.log(location,'l-----------');
                return location
            }, 
            CENTRE_HEADER_ITEMS(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"Number",value:'no',show:false},     
                    {id:0,name:"",value:'icon',show:true},     
                    {id:0,name:"Region",value:"region_name",show:true},          
                    {id:0,name:"Region Code",value:"region_code",show:false},       
                    {id:0,name:"District",value:"district_name",show:true},       
                    {id:0,name:"District Code",value:"district_code",show:false},       
                    {id:0,name:"Constituency",value:"constituency_name",show:true},  
                    {id:0,name:"Constituency Code",value:"constituency_code",show:false},       
                    {id:0,name:"TA",value:"tradition_authority_name",show:true},       
                    {id:0,name:"Tradition Authority code",value:"tradition_authority_code",show:false},       
                    {id:0,name:"Ward",value:"ward_name",show:true},  
                    {id:0,name:"Ward Code",value:"ward_code",show:false},  
                    {id:0,name:"Centre",value:"centre_name",show:true},  
                    {id:0,name:"Centre Code",value:"centre_code",show:false},       
                    {id:0,name:"update",value:'updated_at_',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"edit"}, 
                        {name:"Archive "+this.NAME_ITEM,action:"archive_item",icon:"mdi-delete"}, 
                    ]}, 
                ]
            }, 

        },
        methods: { 
            TABLE_ACTION(action,item){
                try {
                    let route = this.route
                    let fullPath = route?route.fullPath:null
                     console.log(action,'action');
                    if (action == "order_stock") {
                        this.MBS.actions.go(fullPath+"/order")
                    }else if (action == "received_stock") {
                        this.MBS.actions.go(fullPath+"/receive")
                    }else if (action == "return_stock") {
                        this.MBS.actions.go(fullPath+"/return")
                    }else if (action == "transfer_stock") {
                        this.MBS.actions.go(fullPath+"/transfer")
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ITEM_ACTION(action,item){
                try { 
                    if (action == "manage_allowed_centres") {
                        console.log(action,item,11111);  
                        this.SELECTED_ITEM = item
                        this.dialog_allowed_centres = true
                    } else if (action == "able_item") {
                        console.log(action,item,11111);   
                    } else {
                        
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            MANAGE_ALLOWED_CENTRES(action,item){
                try {
                    this.dialog_allowed_centres = true 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'MANAGE_ALLOWED_CENTRES',
                        page:PAGE_NAME, 
                    }) 
                } 
            },

             
            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===PAGE_NAME+'=ADD-ITEM') {
                            if (action.YES) {
                                if (this.input.check) { 
                                    this.input.check = false 
                                    setTimeout(() => {
                                        this.input.loading = true 
                                        this.$store.dispatch("fi_add",{
                                            action:this.VALUE_ITEM,
                                            path:this.PATH_ITEM,
                                            data:action.data,
                                            us:this.us
                                        })
                                    }, ACTION_TIME);  
                                }   
                            } else {
                                
                            }
                        }  
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            FEEDBACKS(time){  
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            }) 
                             
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            },
              
        },
        watch: {  
            loading:{ 
                handler:"FEEDBACKS",
                immediate:true
            } ,
            processes:{ 
                handler:"FEEDBACKS",
                immediate:true
            },
            responses:{ 
                handler:"FEEDBACKS",
                immediate:true
            } 
        },
    }
</script>
 
